export const HOME_PATH = '/';
export const GLOBAL_IMPACT_PATH = '/global-impact';
export const TRENDS_PATH = '/trends';
export const BREAKDOWN_PATH = '/breakdown';
export const FACTSHEETS_PATH = '/factsheets';

export const WOMEN_AND_CARDIOVASCULAR_DISEASE_COMMISSION_PATH = 'https://womencvdcommission.org';
export const ABOUT_PATH = 'https://womencvdcommission.org/about/';
export const OUR_AIMS_PATH = 'https://womencvdcommission.org/about/our-aims/';
export const COMMISSIONERS_AND_COLLABORATORS_PATH = 'https://womencvdcommission.org/about/commissioners/';
export const SPONSORS_PATH = 'https://womencvdcommission.org/about/sponsors/';
export const RESOURCES_PATH = 'https://womencvdcommission.org/resources/';
export const REPORTS_PATH = 'https://womencvdcommission.org/resources/reports/';
export const TEMPLATES_PATH = 'https://womencvdcommission.org/resources/templates-2/';
export const LINKS_PATH = 'https://womencvdcommission.org/resources/links/';
export const EVENTS_PATH = 'https://womencvdcommission.org/events/';
export const DATA_MAPS_PATH = HOME_PATH;
